<script lang="ts" context="module">
  import PageFooter from "./show_new/PageFooter.svelte";
  import { createShowContext } from "./show_new/showContext";
  import Toolbar from "./show_new/Toolbar.svelte";
  import { createSocialButtonContext } from "./show_author_new/socialContext";
  import { onMount } from "svelte";
  import ContactAuthorModal from "./show_new/ContactAuthorModal.svelte";
  import SubscribeToListModal from "./show_new/SubscribeToListModal.svelte";
  import TableOfContent from "./show_new/TableOfContent.svelte";
</script>

<script lang="ts">
  export let newsletterId: string;
  export let showPromotionBar: boolean;
  export let showFullBar: boolean;
  export let showMinimalBar: boolean;
  export let showSocialIcons: boolean;
  export let showAddReaction: boolean;
  export let showTranslations: boolean;
  export let showAccessibilityIcons: boolean;
  export let translateView: boolean;
  export let shortUrl: string;
  export let canonicalUrl: string;
  export let screenshotUrl: string;
  export let metaTitle: string;
  export let smoreBaseDomain: string;
  export let smoreImageUrl: string;
  export let itsAwesomeImageUrl: string;
  export let showTOC: boolean = false;

  let isContactAuthorOpen: boolean = false;
  let isSubscribeToListOpen: boolean = false;
  let listId: string = "";

  createShowContext({
    showPromotionBar,
    showFullBar,
    showMinimalBar,
    showSocialIcons,
    showAddReaction,
    showTranslations,
    showAccessibilityIcons,
    translateView,
    smoreImageUrl,
    itsAwesomeImageUrl,
    showTOC
  });

  createSocialButtonContext({
    newsletterId,
    shortUrl,
    metaTitle,
    canonicalUrl,
    screenshotUrl,
    smoreBaseDomain
  });

  // Handle tracked url fixes
  function handleTrackedLinks(e: MouseEvent | TouchEvent) {
    const t = e.target?.closest("a.skip-tracking[track-href]");
    if (t) {
      // @ts-ignore
      if (t.classList.contains("fancy-pic") && e.buttons === 1) {
        return;
      }
      t.href = t.getAttribute("track-href") || t.href;
    }
  }

  function showContactAuthorModal() {
    isContactAuthorOpen = true;
  }

  function showSubscribeToListModal(e: Event) {
    const evt = e as MouseEvent;
    listId = (e.target as HTMLButtonElement).dataset.listId || "";
    isSubscribeToListOpen = true;
  }

  function registerSignatureButtonEvents() {
    const urlParts = document.URL.split("#");
    let urlAnchor;
    if (urlParts.length > 1) {
      urlAnchor = urlParts[1];
    }
    const contactUserButton = document.querySelector("#contact_user");
    if (contactUserButton) {
      contactUserButton.addEventListener("click", showContactAuthorModal);
      if (urlAnchor === "contact_user") {
        (contactUserButton as any).click();
      }
    }
    const subscribeUserButton = document.querySelector("#subscribe_user");
    if (subscribeUserButton) {
      subscribeUserButton.addEventListener("click", showSubscribeToListModal);
      if (urlAnchor === "subscribe_user") {
        (subscribeUserButton as any).click();
      }
    }
  }

  onMount(registerSignatureButtonEvents);
</script>

<svelte:body on:mousedown={handleTrackedLinks} on:touchstart={handleTrackedLinks} />
{#if showTOC}
  <TableOfContent />
{/if}

<ContactAuthorModal bind:isOpen={isContactAuthorOpen} />
<SubscribeToListModal bind:isOpen={isSubscribeToListOpen} bind:listId />

<Toolbar />
<PageFooter />
